import Vue, { CreateElement } from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Course from './views/Course.vue';
import Home from './views/Home.vue';
import Discipline from './views/Discipline.vue';
import Lesson from './views/Lesson.vue';
import Library from './views/Library.vue';
import Channel from './views/Channel.vue';
import NotFound from './views/404.vue';
import Schedule from './views/Schedule.vue';
import Navigation from './views/Navigation.vue';
import Analytics from './helpers/analytics';
import Forum from './views/Forum.vue';
import CreateDiscussion from './views/CreateDiscussion.vue';
import Discussion from '@/views/Discussion.vue';
import Notebook from '@/views/Notebook.vue';
import SharedNotebook from '@/views/SharedNotebook.vue';
import Revision from '@/views/Revision.vue';
import RevisionResult from '@/views/RevisionResult.vue';
import DesConverse from '@/views/DesConverse.vue';
import Live from '@/views/Live.vue';
import LinkedInCallback from '@/views/LinkedInCallback.vue';
import OAuthCallback from '@/views/OAuthCallback.vue';
import Survey from '@/views/Survey.vue';
import { ENDPOINTS } from './settings/endpoints';

Vue.use(VueRouter);

const component = {
  render: (c: CreateElement) => c('router-view'),
};

const routes: RouteConfig[] = [
  {
    path: '/',
    component: Navigation,
  },
  {
    path: '/:category/',
    component,
    children: [
      {
        path: 'caderno-compartilhado/:notebookHash',
        name: 'sharedNotebook',
        component: SharedNotebook,
      },
      {
        path: 'oauth2callback/:provider',
        name: 'oAuth2Callback',
        component: OAuthCallback,
      },
      {
        path: 'linkedin-integration/callback',
        name: 'linkedInCallback',
        component: LinkedInCallback,
      },
    ],
  },
  {
    path: '/:category/pesquisa/',
    component: Navigation,
    children: [
      {
        path: ':name',
        name: 'survey',
        component: Survey,
      },
    ],
  },
  {
    path: '/:category/preview/',
    component,
    children: [
      {
        path: 'review-list/:revisionSlug',
        name: 'previewReviewList',
        component: Revision,
      },
      {
        path: 'review-list-result/:revisionSlug',
        name: 'previewReviewListResult',
        component: RevisionResult,
      },
      {
        path: 'discipline-instance/:disciplineSlug',
        component,
        children: [
          {
            path: '/',
            name: 'previewDisciplineInstance',
            component: Discipline,
          },
          {
            path: 'lesson/:lessonSlug',
            name: 'previewDisciplineInstanceLesson',
            component: Lesson,
          },
        ],
      },
      {
        path: 'lesson/:lessonSlug',
        name: 'previewLesson',
        component: Lesson,
      },
    ],
  },
  {
    path: '/:category/:currentCourse',
    component,
    children: [
      {
        path: '/',
        component: Navigation,
        children: [
          {
            path: '/',
            name: 'home',
            component: Home,
          },
          {
            path: 'disciplinas',
            name: 'classrooms',
            component: Course,
          },
          {
            path: 'turma/:disciplineSlug',
            name: 'classroom',
            component: Discipline,
          },
          {
            path: 'forum',
            name: 'forum',
            component: Forum,
          },
          {
            path: 'cadernos',
            name: 'notebooks',
            component: Notebook,
          },
          {
            path: 'library',
            name: 'library',
            component: Library,
          },
          {
            path: 'forum/canal/:channelId',
            name: 'channel',
            component: Channel,
          },
          {
            path: 'desconverse',
            name: 'desconverse',
            component: DesConverse,
          },
        ],
      },
      {
        path: 'forum/canal/:channelId/criar-discussao',
        name: 'createDiscussion',
        component: CreateDiscussion,
      },
      {
        path: 'forum/canal/:channelId/discussao/:discussionId',
        name: 'discussion',
        component: Discussion,
      },
      {
        path: 'turma/:disciplineSlug/aula/:lessonSlug',
        name: 'lesson',
        component: Lesson,
        props: true,
      },
      {
        path: 'agendamento',
        name: 'schedule',
        component: Schedule,
      },
      {
        path: 'turma/:disciplineSlug/revision/:revisionSlug',
        name: 'revision',
        component: Revision,
      },
      {
        path: 'turma/:disciplineSlug/revisionResult/:revisionSlug',
        name: 'revisionResult',
        component: RevisionResult,
      },
      {
        path: ':paramsSlug/live/:liveId',
        name: 'live',
        component: Live,
      },
    ],
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: ENDPOINTS.baseUrlWithoutUndergrad,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { y: 81, x: 0 },
      };
    }

    return { x: 0, y: 0 };
  },
  routes,
});
router.afterEach(async () => {
  await Analytics.registerIfIsInTrial();
  Analytics.trackPageView();
});

export default router;
